const overrides = (palette, typography) => ({
  gutterBottom: {
    marginBottom: "0.6em"
  }
})

export default overrides
